import { ApplicationConfig, provideZoneChangeDetection, provideAppInitializer, inject } from '@angular/core';
import { PreloadAllModules, provideRouter, Router, withPreloading } from '@angular/router';

import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from '@interceptors/auth.interceptor';
import { provideTranslateService, TranslateLoader, TranslateService, } from "@codeandweb/ngx-translate";
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideServiceWorker } from '@angular/service-worker';
import { MsalAuthService } from './msal/msal-auth.service';
import { ModulePaths } from '@constants/url.constant';
import { delay as delayUtil } from '@utils/common.utils';
import { delay, firstValueFrom } from 'rxjs';
import { DatePipe } from '@angular/common';
import { CustomTranslateLoader } from './translate-loader/translate-loader';
import { NetworkService } from '@services/network/network.service';
import { Environment } from '@environment/environment';
import { EnvironmentNames } from '@environment/environment.enum';
import { StorageService } from '@services/storage/storage.service';
import { SYNC_IN_PROGRESS } from '@services/storage/storage.keys.constant';


let defaultLanguage = 'en';
try {
  const storedLanguage = localStorage.getItem('app_data_SELECTED_LANGUAGE_KEY');
  if (storedLanguage) {
    const parsedLanguage = JSON.parse(storedLanguage);
    defaultLanguage = parsedLanguage.languageCode ?? 'en';
  } 
} catch (error) {
  defaultLanguage = 'en';
}




export const appConfig: ApplicationConfig = {
  providers: [
    DatePipe,
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAppInitializer(async () => {
      const msalAuthService = inject(MsalAuthService);
      const router = inject(Router);
      const networkSvc = inject(NetworkService);
      const storageSvc = inject(StorageService);
      try {
        storageSvc.removeSession(SYNC_IN_PROGRESS);
        const currentUrl = window.location.pathname;
        if (currentUrl.includes('/public')) {
          // Your public route logic here
          console.log('Public route detected');
          // If you want to skip authentication for public routes
          return Promise.resolve();
        }
        if(!networkSvc.isOnline) {
          return await router.navigateByUrl(ModulePaths.HOME + '/' + ModulePaths.DASHBOARD);
        }
        if (!msalAuthService.msalInstance) {
          msalAuthService.msalInstance = await msalAuthService.init();
        }
        await msalAuthService.msalInstance.initialize();
        await delayUtil(1000);
        if (msalAuthService.isAuthenticated) {
          
          const authStr = location.hash.substring(2, 6);
          if (authStr === ModulePaths.AUTH) {
            if(msalAuthService.getAccessToken()) {
              const value  = await firstValueFrom(msalAuthService.authChanged$.asObservable().pipe(delay(1500)));
            } else {
              const value  = await firstValueFrom(msalAuthService.authChanged$.asObservable().pipe(delay(1500)));
            }
            await router.navigateByUrl(ModulePaths.HOME + '/' + ModulePaths.DASHBOARD);
            return Promise.resolve();
          }
          if(msalAuthService.getAccessToken()) {
            const value  = await firstValueFrom(msalAuthService.authChanged$.asObservable().pipe(delay(1500)));
          } else {
            const value  = await firstValueFrom(msalAuthService.authChanged$.asObservable().pipe(delay(1500)));
          }
          
          return Promise.resolve();
        }
        await msalAuthService.Login();
        const value  = await firstValueFrom(msalAuthService.authChanged$.asObservable().pipe(delay(1500)));
        await router.navigateByUrl(ModulePaths.HOME + '/' + ModulePaths.DASHBOARD);
        return Promise.resolve()
      } catch (err) {
        await router.navigateByUrl(ModulePaths.AUTH + '/' + ModulePaths.AUTH_FAILED);
        return Promise.resolve();
      } finally {
        document.body.removeChild(document.getElementById('wait-text') as HTMLElement);
      }
    }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
      deps: [MsalAuthService],
    },
    provideTranslateService({
      defaultLanguage: defaultLanguage,
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader
        
      },
    }),
    TranslateService, provideServiceWorker('ngsw-worker.js', {
      enabled: Environment.environment !== EnvironmentNames.local,
      registrationStrategy: 'registerImmediately'
          })
  ],
};
